import PropTypes from 'prop-types'
import { StyledContainer } from './styled-components'
import useResources from './useResources'
import ActionTile from '@/containers/SubscriptionFormPageNew/Components/shared/ActionTile/ActionTile'
import { TileGrid } from '@/containers/SubscriptionFormPageNew/Components/shared/ActionTile/styled-components'
import ModuleToggle from '@/containers/SubscriptionFormPageNew/Components/shared/ModuleCollapse/ModuleToggle'
import ModuleHeading from '@/containers/SubscriptionFormPageNew/Components/shared/ModuleCollapse/ModuleHeading'
import useModuleCollapse from '@/containers/SubscriptionFormPageNew/Components/shared/ModuleCollapse/useModuleCollapse'
import {
  ModuleBody,
  ModuleContent,
} from '@/containers/SubscriptionFormPageNew/Components/shared/ModuleCollapse/styled-components'
import ModuleHeader from '@/containers/SubscriptionFormPageNew/Components/shared/ModuleCollapse/ModuleHeader'
import IconCarbonInformation from '@/shared/icons/IconCarbonInformation'

const Resources = ({ country }) => {
  const { t, resources, hidden } = useResources(country)
  const { expanded, toggle } = useModuleCollapse('resources')
  if (hidden) {
    return null
  }

  return (
    <StyledContainer>
      <ModuleHeader clickable onClick={toggle}>
        <ModuleHeading icon={IconCarbonInformation} moduleKey='resources'>
          {t('subscriptionForm:resources.section_title')}
        </ModuleHeading>
        <ModuleToggle expanded={expanded} onToggle={toggle} moduleKey='resources' />
      </ModuleHeader>
      <ModuleContent hidden={!expanded}>
        <ModuleBody>
          <TileGrid>
            {resources.map(({ key, href, label, icon: Icon }) => (
              <ActionTile key={key} href={href} label={label} icon={<Icon size={18} />} />
            ))}
          </TileGrid>
        </ModuleBody>
      </ModuleContent>
    </StyledContainer>
  )
}

Resources.propTypes = {
  country: PropTypes.string,
}

export default Resources
